import { initProgramInstance, getBlockHeight } from '../../chains/svm/api';
import { SVMChain } from '../../types';
import { WEB3_ADDRESS } from '../../wallet';
import { getFastestRpc } from '../../utils/common';
export async function initSvmProvider(svmWallet, onProgramReady, toast) {
    const solanaChainInfo = WEB3_ADDRESS[SVMChain.Solana];
    if (!solanaChainInfo) {
        toast.error(`SVM doesn't have valid RPC`);
        return;
    }
    const rpc = await getFastestRpc(solanaChainInfo.rpc, getBlockHeight);
    if (!rpc) {
        toast.error(`SVM doesn't have valid RPC`);
    }
    initProgramInstance(svmWallet, rpc ?? solanaChainInfo.rpc[0], onProgramReady);
}
